module.exports = __webpack_public_path__ + "static/11-b627151792af8d9199de19ffe84ac8c9.jpg";